import Modal from 'LuxKit/Modal/Modal'
import React from 'react'
import { useIntl } from 'react-intl'
import ReserveForZeroPolicyModalContent from './ReserveForZeroPolicyModalContent'

interface Props {
  isOpen?: boolean
  onClose?: React.MouseEventHandler<HTMLElement>
}

function ReserveForZeroPolicyModal(props: Props) {
  const { isOpen, onClose } = props
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'vhfHInI506',
        defaultMessage: 'Reserve now for free',
        description: 'Modal title for reserve for zero policy in a modal dialog',
      })}
      isOpen={isOpen}
      onClose={onClose}
      height="full"
      tabletHeight="auto"
      subtitle={intl.formatMessage({
        id: 'vL10DWh/mC',
        defaultMessage: 'Reserve a hotel now for free before being charged after 48 hours.',
        description: 'Modal subtitle explaining reserve for zero policy in a modal dialog',
      })}
      size="L"
    >
      <ReserveForZeroPolicyModalContent />
    </Modal>
  )
}

export default ReserveForZeroPolicyModal
